import { FC } from "react";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { Box, Flex, Grid, Heading, Text } from "@radix-ui/themes";
import CoverCarousel from "@/components/CoverCarousel/CoverCarousel";
import { logitechCarousel } from "@/features/home/constants/logitechCarousel";

const HomePageLogitech: FC = (): JSX.Element => {
  // Page Document Title
  useDocumentTitle("Welcome - Home");

  return (
    <Box>
      <CoverCarousel slides={logitechCarousel} interval={12000} />
      <Heading as="h2" size={{ initial: "8", md: "9" }} mb="3">
        BACKGROUND
      </Heading>
      <Text weight="light" size="4">
        Logitech G Changes Eracing
      </Text>
      <Grid columns={{ initial: "1", md: "2" }} gap="4" mt="6">
        <Flex direction="column" gap="4">
          <Text as="p" size="3">
            A major innovator in the sim racing game, Logitech G first pioneered
            its own gaming wheel in 1998. Over 20 years later, G29 continue the
            heritage of great force-feedback racing wheels, a culmination of
            years of community feedback and technological advances built into a
            radically improved design.
          </Text>
          <Text as="p" size="3">
            Logitech’s exemplifies the beauty of well-engineered force feedback,
            as immersive driving simulation comes to life in the details.
          </Text>
          <Text as="p" size="3">
            Dual-motor force feedback makes you feel every tire slip and terrain
            change; solid steel ball bearings give weight and durability.
            Helical-cut gears—modeled after gears used in automotive
            transmissions—provide a smooth, quiet steering action through
            various force feedback types.
          </Text>
        </Flex>
        <Flex direction="column" gap="4">
          <Text as="p" size="3">
            Stainless steel paddle shifters and floor pedals with anti-backlash
            apply precision force, maximizing control, and delivering a
            realistic sim racing experience. The Driving Force Racing Wheel also
            features a long lasting, reliable hall-effect steering sensor, using
            magnetic fields to sense the position of the wheel.
          </Text>
          <Text as="p" size="3">
            {" "}
            lets you drive fearlessly knowing the wheel won’t shift during
            aggressive maneuvers. The racing wheel mounts securely to your table
            or racing rig via built-in clamps or screw mounting points. G29
            —wheel, pedals and shifter—mount perfectly in Playseat® racing
            simulation cockpits for added realism.
          </Text>
        </Flex>
      </Grid>
    </Box>
  );
};

export default HomePageLogitech;
